export function EditEventModal({ event, isSaving, minEndDate, setMinEndDate, onClose, onSubmit }) {
  return (
    <div className="modal-overlayAdmin">
      <div className="modal-contentAdmin">
        <div className="modal-header">
          <h3>Update Event</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={onSubmit} className="FormUpdateEvent">
          <div className="form-group">
            <label>Event Title</label>
            <input name="title" type="text" required defaultValue={event.title} />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea name="description" required defaultValue={event.description} placeholder="Describe the event..." rows="4" />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Location Name</label>
              <input name="locationName" type="text" placeholder="Where is it?" defaultValue={event.locationName || ""} />
            </div>
            <div className="Location-Row">
              <div className="form-group">
                <label>Full Address</label>
                <input name="address" type="text" placeholder="Street, City" defaultValue={event.address || ""} />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Event Date Start</label>
              <input name="startDate" type="date" required onChange={(e) => setMinEndDate(e.target.value)} defaultValue={event.startDate} />
            </div>
            <div className="form-group">
              <label>Start Time</label>
              <input name="startTime" type="time" required defaultValue={event.startTime} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Event Date End</label>
              <input name="endDate" type="date" required min={minEndDate || event.startDate} defaultValue={event.endDate} />
            </div>
            <div className="form-group">
              <label>End Time</label>
              <input name="endTime" type="time" required defaultValue={event.endTime} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? "Saving..." : "Save the modification"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}